import { TextField, TextFieldProps } from '@mui/material';

import { withSanitization } from '../../hoc/sanitization/withSanitization';

export const TextFieldBase: React.FC<TextFieldProps> = (props) => <TextField {...props} />;
const TextFieldWrapper = withSanitization<TextFieldProps, unknown>(TextFieldBase);

export default TextFieldWrapper;
